export default "__VITE_ASSET__CZ92_F8X__"